import React, { Component } from 'react';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';
import { CustomCard } from "../../components/Card/CustomCard";

import { UpdPerfil } from '../../funciones/PefilFunction';

class ChangePass extends Component {
    state = {
        boton1: {
            Icon:"fa fa-save",
            Title:"Guardar"
        },
        pass1: "",
        pass2: "",
        pass3: "",
        cantErrores: "",
    }

    cambiaValor = (prop) => (event) => {
        this.setState({ [prop]:event.target.value });
    };

    guardar = () => (e) => {
        let { pass1, pass2, pass3 } = this.state;
        const campos = { pass1, pass2, pass3 };

        this.setState({
            boton1: {
                Icon:"fa fa-spinner fa-spin",
                Title:"Espera por favor"
            }
        }, () => {
            UpdPerfil(campos, (resp) => {
                let mensaje = resp[2];
                let errores = resp[0];
                let nameErrores = resp[1]
                let contentErr = [];

                for (let i in nameErrores) {
                    if (nameErrores[i] !== "") contentErr.push(
                        <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
                    )
                }

                if (errores === 0) this.setState({ cantErrores:"" })

                let mess = (mensaje) => {        
                    this.setState({
                        boton1:{
                            Icon:"fa fa-save",
                            Title:"Guardar",
                        }
                    }, () => {
                        toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
                    })
                }

                let erroresList = (
                    <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                        {contentErr}
                    </Popover>
                )

                if (mensaje[0].status === "error" && errores !== 0) this.setState ({
                    cantErrores: <div style={{paddingTop:10}}>
                                    Se han encontrado {errores} error(es). Haz click <span>
                                    <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                        <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                                    </OverlayTrigger></span> para verlos
                                </div>
                })

                mess(mensaje[0]);
            })
        })
    }

    contenido = () => {
        let { boton1, pass1, pass2, pass3, cantErrores } = this.state
        return(
            <Row>
                <Col md={6}>
                    <div className="text-muted">Ingresa tu contraseña actual</div>
                    <input type="password" value={pass1} onChange={this.cambiaValor("pass1")} className="form-control" placeholder="Ingresa tu contraseña" />
                </Col>
                <Col md={12} className="custom-mt-10">
                    <Row>
                        <Col md={6}>
                            <div className="text-muted">Ingresa tu nueva contraseña</div>
                            <input type="password" value={pass2} onChange={this.cambiaValor("pass2")} className="form-control" placeholder="Nueva contraseña" />
                        </Col>
                        <Col md={6}>
                            <div className="text-muted">Repite la nueva contraseña</div>
                            <input type="password" value={pass3} onChange={this.cambiaValor("pass3")} className="form-control" placeholder="Repite la contraseña" />
                        </Col>
                    </Row>
                </Col>
                <Col md ={7} className="custom-mt-20"><div className="text-danger">{ cantErrores }</div></Col>
                <Col md={5} className="custom-mt-20" align="right">
                    <button className="btn btn-primary" onClick={this.guardar()} style={{borderWidth:1}}><i className={boton1.Icon}></i> {boton1.Title}</button>
                </Col>
            </Row>
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                Para cambiar la contraseña de inicio de sesión es necesario que primero ingreses la contraseña actual de tu usuario
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                Ingresa la nueva contraseña y confírmala y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-save"></i> Guardar</button>
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                <strong>Importante:</strong> Si no recuerdas tu contraseña actual, puedes ir a la ventana de inicio de sesión y presionar la opción <a>Olvidé mi contraseña</a>
            </Col>
        </Row>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div style={{borderRadius: "4px 4px"}}>
                            <CustomCard
                                title="Cambiar Contraseña"
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Cambiar Contraseña</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default ChangePass;


// WEBPACK FOOTER //
// ./src/views/Perfil/ChangePass.jsx